import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-00ac83d8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "my-tickets-root-page main-scroll-topbar-content"
};
const _hoisted_2 = {
  class: "order-content order-content-all"
};
const _hoisted_3 = {
  key: 0,
  class: "ticket-list-box"
};
const _hoisted_4 = {
  class: "order-id-box"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "left-part"
};
const _hoisted_8 = {
  class: "price-box"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "color-block color-block-1"
}, null, -1));

const _hoisted_10 = {
  class: "price-text"
};
const _hoisted_11 = {
  class: "price-number"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price-tag"
}, "RMB", -1));

const _hoisted_13 = {
  class: "tickeks-title"
};
const _hoisted_14 = {
  class: "right-part"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "buy-now"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  key: 1
};
import TopNavigator from "../components/TopNavigator.vue";
import { ref, onBeforeMount } from "vue";
import request from "../assets/utils/request";
import { Toast } from "vant";
import router from "../router";
import CommonBtn from "../components/CommonBtn.vue";
import { nftShopApi } from "../common.config";
export default {
  __name: 'MyTickets',
  props: {},

  setup(__props) {
    const props = __props; // 状态文案

    const statusMap = {
      pending: "待支付",
      paid: "待使用",
      finished: "已完成",
      closed: "已关闭"
    }; // 付款文案

    const payMap = {
      pending: "待付款：",
      paid: "实付款：",
      finished: "实付款：",
      closed: "应付款："
    }; // 操作按钮文案

    const operateBtnMap = {
      pending: "去支付",
      paid: "查看券码",
      finished: "查看详情",
      closed: "查看详情"
    };
    onBeforeMount(() => {
      fetch();
    }); // 获取订单

    const orders = ref(null);

    const fetch = (status = "all") => {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      request.get(`${nftShopApi}/order/info?req_type=paid`).then(res => {
        if (res.code == 200) {
          orders.value = res.data;
          orders.value.forEach((item, index) => {
            item.priceStr = Number(item.price) / 100;
            item.totalFeeStr = (item.totalFee / 100).toFixed(2);
            item.statusStr = statusMap[item.status];
            item.payStr = payMap[item.status];
            item.operateBtnStr = operateBtnMap[item.status];
          });
          Toast.clear();
        } else {
          Toast.fail("加载失败");
        }
      }).catch(err => {
        Toast.clear();
        console.error("获取订单：", err);
      });
    }; // 查看详情


    const handleToDetail = orderId => {
      router.push(`/user-order-detail?orderId=${orderId}`);
    }; // 快捷按钮操作


    const handleToOperate = orderInfo => {
      // 去详情页面查看票券、或订单详情
      router.push(`/user-order-detail?orderId=${orderInfo.objectId}`);
    };

    return (_ctx, _cache) => {
      const _component_van_empty = _resolveComponent("van-empty");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "待使用票券"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [orders.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [orders.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(orders.value, order => {
        var _order$ticketCatInfo, _order$ticketCatInfo2;

        return _openBlock(), _createElementBlock("div", {
          class: "ticket-item",
          key: order.objectId
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(order.isRedeem ? "兑换" : "订单") + "编号：" + _toDisplayString(order.objectId), 1), _hoisted_5]), _createElementVNode("div", {
          class: "ticket-info",
          onClick: $event => handleToDetail(order.objectId)
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(order === null || order === void 0 ? void 0 : order.priceStr), 1), _hoisted_12])]), _createElementVNode("div", _hoisted_13, _toDisplayString(order === null || order === void 0 ? void 0 : (_order$ticketCatInfo = order.ticketCatInfo) === null || _order$ticketCatInfo === void 0 ? void 0 : _order$ticketCatInfo.name) + "·极客公园创新大会2023", 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
          class: "ticket-cover-img",
          src: order === null || order === void 0 ? void 0 : (_order$ticketCatInfo2 = order.ticketCatInfo) === null || _order$ticketCatInfo2 === void 0 ? void 0 : _order$ticketCatInfo2.cover
        }, null, 8, _hoisted_15)])], 8, _hoisted_6), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
          class: "tickeks-tips",
          onClick: $event => handleToDetail(order.objectId)
        }, _toDisplayString(order.isRedeem ? "兑换成功" : order.payStr + "￥" + order.totalFeeStr), 9, _hoisted_17), _createVNode(CommonBtn, {
          text: order.operateBtnStr,
          width: "134px",
          height: "32px",
          params: order,
          onHandleClick: handleToOperate
        }, null, 8, ["text", "params"])])]);
      }), 128)) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        description: "还没有待使用票券，快去购票吧~"
      }))])) : (_openBlock(), _createElementBlock("div", _hoisted_18))])])], 64);
    };
  }

};